export default __webpack_public_path__ + "static/Entenda0128-8c50caa2ef517168103599a1d7584b2a.jpg";